// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AEUkBkNJof {
	min-width: 76px;
	padding: 2px 5px 1px 5px;
}
`, "",{"version":3,"sources":["webpack://./../confluence-editor/src/editor-plugins/status-macro/css/status-view.module.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,wBAAwB;AACzB","sourcesContent":[".status-macro {\n\tmin-width: 76px;\n\tpadding: 2px 5px 1px 5px;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `AEUkBkNJof`;
export { _1 as "status-macro" };
export default ___CSS_LOADER_EXPORT___;
